import React from 'react';
import { Navigate } from 'react-router-dom';

import { usePatient } from 'hooks/usePatient/usePatient';
import { utils } from 'kb-shared';
import { pageUrl } from 'utilities/pageUrl';

export const LegacyIntakeFormRedirect = () => {
  const { patient } = usePatient();
  return <Navigate to={pageUrl.patientForm(utils.intakeFormId(patient?.gender))} replace />;
};
